export default defineNuxtRouteMiddleware((to) => {
  const { $pinia } = useNuxtApp()
  const appStore = useAppStore($pinia)

  if (to.query?.devMode === 'true') {
    appStore.$patch({ devMode: true })
  }
})
